import { imageBasePath } from 'constants';
import { InputSelect } from 'shared_ui_components';
import { CustomButton } from 'shared_ui_components';
import RealPlayQualifiedLogic from './RealPlayQualified.logic';
import classes from './ReviewQualifiedRealPlay.module.scss';

const containerStyles = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: '1rem',
  alignItems: 'center',
};

const NewRealPlayHeader = ({ isPublic = false }) => {
  const {
    navigate,
    PATHS,
    reset,
    title,
    onSelectedValue,
    scenariosLength,
    value,
    options,
    final_decision,
    confirmAll,
    handlePass,
    handleFail,
    navigateNext,
    isNewDisabled,
    generateRoleplayHeader,
  } = RealPlayQualifiedLogic();

  return (
    <>
      <div style={containerStyles}>
        {!isPublic && (
          <button
            onClick={() => {
              navigate(PATHS.ROLEPLAYS);
              reset();
            }}
          >
            <img src={imageBasePath + 'back_arrow.svg'} alt="Return" />
          </button>
        )}
        <span className="heading4">{generateRoleplayHeader(title)}</span>
      </div>
      <div className={classes.flexContainer}>
        {scenariosLength > 1 && (
          <div className={classes.scenarioSelector}>
            <InputSelect
              value={value}
              onChange={(opt) => onSelectedValue(opt?.value || '')}
              options={options}
              closeMenuOnSelect
            />
          </div>
        )}
        {confirmAll ? (
          <CustomButton onClick={() => navigateNext()} className="primaryBtn">
            Confirm result
          </CustomButton>
        ) : (
          <CustomButton
            onClick={final_decision === 'FAIL' ? () => handleFail() : () => handlePass()}
            className="primaryBtn"
            disabled={isNewDisabled}
          >
            Confirm result
          </CustomButton>
        )}
      </div>
    </>
  );
};

export default NewRealPlayHeader;
